export function getBaseUrl() {
  if (import.meta.env.VITE_FRONT_ENVIRONMENT === "dev") {
    return `${import.meta.env.VITE_DEV_BACK_API}/api`;
  } else if (import.meta.env.VITE_FRONT_ENVIRONMENT === "prod") {
    return `${import.meta.env.VITE_PROD_BACK_API}/api`;
  }
  return `http://localhost:3000`;
}
